import 'custom-event-polyfill';
import T from 'terrific';
import jQuery from 'jquery';

const requireAll = requireContext => {
		return requireContext.keys().map(requireContext);
	},
	bootstrapTerrific = () => {
		const application = new T.Application(document.body);
		application.registerModules();
		application.start().catch(function(err) {
			console.error(err); // eslint-disable-line no-console
		});
	};

// JavaScript patterns and assets
// -> <name>.js
requireAll(require.context('../Assets/Js', true, /^((?![\\/]node_modules|spec[\\/]).)*\.js$/));
requireAll(require.context('../Components', true, /^((?![\\/]node_modules|spec[\\/]).)*\.js$/));

// -> <name>.css
requireAll(require.context('../Assets/Css', true, /^((?![\\/]node_modules[\\/]).)*\.scss$/));
requireAll(require.context('../Components/Atoms', true, /Css\/[A-z-]*\.scss$/));
requireAll(require.context('../Components/Atoms', true, /Css\/Modifier\/[A-z0-9\-.]*\.scss$/));
requireAll(require.context('../Components/Molecules', true, /Css\/[A-z-]*\.scss$/));
requireAll(require.context('../Components/Molecules', true, /Css\/Modifier\/[A-z0-9\-.]*\.scss$/));
requireAll(require.context('../Components/Organisms', true, /Css\/[A-z-]*\.scss$/));
requireAll(require.context('../Components/Organisms', true, /Css\/Modifier\/[A-z0-9\-.]*\.scss$/));

/*
 * When the DOM is ready, trigger terrific.
 */
jQuery(document).ready(() => {
	bootstrapTerrific();
});
